import { Injectable } from '@angular/core';

/**
 * Awatar użytkownika: pierwsza litera nazwy na barwie wyliczonej z ziarna.
 *
 * Ziarnem jest nazwa użytkownika i tylko ona — jedyne, co o człowieku wiadomo wszędzie tam, gdzie rysujemy awatar.
 * Identyfikator z Keycloaka zna pasek górny, ale nie zna go tabela zarządzania; identyfikator z bazy jest odwrotnie.
 * Ziarno różne w dwóch widokach daje temu samemu koncu dwie różne barwy, więc wybór jest tu, a nie u wołającego.
 */
@Injectable({
  providedIn: 'root'
})
export class AvatarService {

  /**
   * Dwanaście barw z palety Materiala, każda w takim wariancie jasności, żeby żadne dwie nie były do pomylenia:
   * odcienie układają się w sześć par sąsiadów na kole barw i w pięciu z nich rozsuwa je dopiero jasność.
   *
   * Odległości liczone w CIEDE2000 — najbliższa para dzieli ΔE 16.7, a poniżej mniej więcej 15 barwy się zlewają.
   * Drugi warunek to biała litera na wierzchu, stąd dolna granica kontrastu 3:1, czyli próg WCAG dla dużego tekstu.
   */
  private readonly PALETTE = [
    '#ef5350', '#c2185b', '#9c27b0', '#311b92',
    '#2196f3', '#01579b', '#009688', '#388e3c',
    '#bf360c', '#ef6c00', '#5d4037', '#607d8b'
  ];

  /* Ten sam skrót, którym Java liczy hashCode napisu: rozrzuca podobne nazwy po różnych barwach. */
  colorOf(username: string): string {
    const text = username ?? '';
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = Math.imul(hash, 31) + text.charCodeAt(i);
    }
    return this.PALETTE[Math.abs(hash) % this.PALETTE.length];
  }

  initialOf(name: string): string {
    return (name ?? '').charAt(0).toUpperCase();
  }
}
